import { useState, useEffect } from "react";
import logo from "../images/logo.png";
import patient2 from "../images/patient2.png";
import office2 from "../images/office2.png";

import "../css/ComponentStyle.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser, setBaseUrl, setAuthToken } from "../redux/actions/userActions";
import { APIConstants, LoginConstants } from "../utilities/Constants";
import VerifyOtp from "./VerifyOtp";
import healthivaLogo from "../images/logo.png";
import "../css/AuroraBackground.css";
import "../css/Login.css";

const Login = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [practicId, setPracticeId] = useState("");
  const [loading, setLoading] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const dispatch = useDispatch();

  const fetchNewToken = async (user) => {
    try {
      const inputJSON = { UserName: user.Username, PracticeId: user.practiceID };
      const url = `${APIConstants.SERVICES_URL}${LoginConstants.UpdatedToken}?sInputJSON=${JSON.stringify(inputJSON)}`;

      const res = await fetch(url);
      if (!res.ok) return;

      const parsedData = await res.json();
      dispatch(setAuthToken(parsedData.AuthToken));
      localStorage.setItem("sAuthToken", parsedData.AuthToken);
    } catch (err) {
      console.error("Token fetch error:", err);
    }
  };


  const handleClick = async (e) => {
    e.preventDefault();

    setErrorMessage("");

    // Validate  fields
    if (!practicId?.trim() || !username?.trim() || !password?.trim()) {
      setErrorMessage("Please complete all fields to continue.");
      return;
    }

    setLoading(true);

    localStorage.removeItem("activePage");

    const inputStruct = {
      PracticeID: practicId,
      Username: username,
      Password: password,
      RoleID: 7,
    };

    const myInput = JSON.stringify(inputStruct);

    const url = `${APIConstants.SERVICES_URL}${LoginConstants.GetLogin}?sInputJSON=${myInput}`;

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          setLoading(false);
          setErrorMessage("Invalid credentials. Please try again.");
          return null;
        }

        return response.json();
      })
      .then((data) => {
        if (!data) return;

        const parsedLoginData = JSON.parse(data);

        if (!parsedLoginData || parsedLoginData.length == 0) {
          setLoading(false);
          setErrorMessage("Invalid credentials. Please try again.");
          return;
        }

        setAuthenticated(true);
        dispatch(setUser(parsedLoginData));

        localStorage.setItem("userToken", "your_token_or_true");

        fetchNewToken(parsedLoginData);

        setLoading(false);

        if (parsedLoginData.sIsOTP == 0) {
          navigate("/locations");
        } else {
          setShowOtpModal(true);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
        setErrorMessage("An error occurred. Please try again later.");
      });
  };

  useEffect(() => {
    document.title = "Login to Healthiva";
    localStorage.removeItem("activePage");
  }, [handleClick]);



  return (
    <>


      <div className="login-page aurora-bg">

        {showOtpModal && (
          <VerifyOtp
            onVerifySuccess={() => navigate("/locations")}
            onClose={() => setShowOtpModal(false)}
          />
        )}
        <div className="login-card">

          {/* LEFT PANEL */}
          <div className="login-left">

            <div className="bubble bubble1"></div>
            <div className="bubble bubble2"></div>
            <div className="bubble bubble3"></div>
            <div className="bubble bubble4"></div>

            <div className="brand">
              <div className="brand-logo">
                <img src={healthivaLogo} alt="Healthiva" />
              </div>
            </div>

            <div className="left-content">
              <h1>
                Billing made
                <br />
                effortless.
              </h1>

              <p>
                Manage claims, payments, and revenue cycle
                from a single secure dashboard.
              </p>

              <div className="feature-pill">
                📄 Claim Submission & Tracking
              </div>

              <div className="feature-pill">
                💳 ERA / EOB Processing
              </div>

              <div className="feature-pill">
                📊 Revenue Cycle Analytics
              </div>

              <div className="feature-pill">
                📑 Patient Statements
              </div>

              <div className="feature-pill">
                🔒 HIPAA-Compliant & Secure
              </div>
            </div>

            <div className="copyright">
              © 2026 Healthiva Inc. All rights reserved.
            </div>
          </div>

          {/* RIGHT PANEL */}
          <div className="login-right">

            <div className="portal-tag">
              ▭ Billing Portal
            </div>

            <h2>Welcome back</h2>

            <p className="subtitle">
              Sign in to your billing account
            </p>

            <form onSubmit={handleClick}>

              <label>PRACTICE ID</label>
              <div className="input-box">
                <span>🏢</span>
                <input
                  type="text"
                  placeholder="Enter your practice ID"
                  value={practicId}
                  onChange={(e) => setPracticeId(e.target.value)}

                  

                />
              </div>

              <label>USERNAME</label>
              <div className="input-box">
                <span>👤</span>
                <input
                  type="text"
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  
                />
              </div>

              <label>PASSWORD</label>
              <div className="input-box">
                <span>🔒</span>
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  
                />
                <span>
                  <FontAwesomeIcon
                    icon={showPassword ? faEye : faEyeSlash}
                    onClick={handleTogglePassword}
                    style={{
                      position: "absolute",
                      right: "18px",
                      top: "10px",
                      cursor: "pointer",
                      color: "#94a3b8",
                    }}
                  />
                </span>
              </div>

              <div className="status-row">
                <span>✅ System Checked</span>
                <span style={{ marginLeft: '0px', display: 'flex' }}>Best in
                  <span style={{ padding: '0px 4px', marginTop: '4px' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4.5" fill="#4285f4"></circle><path d="M12 7.5h8.66A10 10 0 0 0 3.34 17L7.5 9.75A5 5 0 0 1 12 7.5z" fill="#ea4335"></path><path d="M20.66 7.5A10 10 0 0 1 3.34 17l4.16-7.25A5 5 0 0 0 12 17a5 5 0 0 0 4.34-2.5z" fill="#34a853"></path><path d="M3.34 17A10 10 0 0 1 12 2v5.5a5 5 0 0 0-4.34 2.5z" fill="#fbbc05"></path></svg>
                  </span> Chrome</span>
              </div>

              {errorMessage && (
                <div
                  id="login-error-message"
                  style={{
                    marginTop: "16px",
                    fontSize: "13px",
                    color: "#c0392b",
                    background: "#fef2f2",
                    border: "1px solid #fecaca",
                    borderRadius: "8px",
                    padding: "10px 14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <span style={{ fontSize: "15px" }}>⚠</span>
                  {errorMessage}
                </div>
              )}

              <button className="login-btn" type="submit"
                disabled={loading}

              >
                {loading ? (
                  <>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" style={{ animation: "spin 0.8s linear infinite" }}>
                      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                    </svg>
                    Signing in…
                  </>
                ) : "Sign In →"}
              </button>

              <div className="forgot-link">

                Forgot your password?
              </div>

              <div className="security mt-5">
                🔒 256-bit SSL encrypted · HIPAA compliant
              </div>

            </form>

          </div>

        </div>
      </div>
    </>
  );
};

export default Login;
